/* global $ */
export class AnchorLinkControl {
	constructor(el) {
		const target = $(el).attr('href')

		// scroll to target position
		if (target !== '#') {
			const $target = $(target)
			if ($target.length) {
				$(el).on('click', (e) => {
					e.preventDefault()

					$('html, body').animate({
						scrollTop: $target.offset().top - 100
					}, 500)
				})
			}
		}
	}
}
